var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, makeObservable } from 'mobx';
import { xa } from '../../../utils/xa/xa';
export class QuestionPassState {
    parent;
    id;
    name;
    color;
    orderInProgressbar;
    isDefaultFiltered = false;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get topicFilter() {
        return this.parent;
    }
    get topic() {
        return this.topicFilter.topic;
    }
    get app() {
        return this.topic.app;
    }
    get questionsOfThisState() {
        return this.app.funnel.funnelMixed.mixedFilter.filteredUnlessQuestionstate.filter(q => q.miniPassState.questionState === this.id);
    }
    get numberOfQuestion() {
        return this.questionsOfThisState.length;
    }
    get storedFilterStates() {
        return this.topic.topicFilter.filterStateQuery.streamedDeep.map(r => r.state);
    }
    get isInStoredFilterList() {
        return this.storedFilterStates.includes(this.id);
    }
    get isFiltered() {
        if (this.isDefaultFiltered && !this.isInStoredFilterList)
            return true;
        if (!this.isDefaultFiltered && this.isInStoredFilterList)
            return true;
        return false;
    }
    addToStoredFilters() {
        this.topicFilter.filterStateQuery.streamedDeep.push({
            id: 0,
            state: this.id,
            topic_id: this.app.topic.id,
            user_id: this.app.user.id,
            timestamp: new Date(),
        });
        xa.personalTopic.addStateFilter({ state: this.id });
    }
    removeFromStoredFilters() {
        this.topicFilter.filterStateQuery.streamedDeep.remove(this.topicFilter.filterStateQuery.streamedDeep.find(x => x.state === this.id));
        xa.personalTopic.removeStateFilter({ state: this.id });
    }
    disableThisPassState() {
        if (this.isDefaultFiltered) {
            this.removeFromStoredFilters();
        }
        else {
            this.addToStoredFilters();
        }
    }
    enableForUser() {
        if (this.isDefaultFiltered) {
            this.addToStoredFilters();
        }
        else {
            this.removeFromStoredFilters();
        }
        this.app.funnel.recalculateFunnel();
        this.app.directive.directivePoseQuestion.removeCurrentQuestionAndRePose();
    }
    toggleFilter() {
        if (this.storedFilterStates.includes(this.id)) {
            this.removeFromStoredFilters();
        }
        else {
            this.addToStoredFilters();
        }
        this.app.directive.directivePoseQuestion.removeCurrentQuestionAndRePose();
    }
}
__decorate([
    computed
], QuestionPassState.prototype, "questionsOfThisState", null);
__decorate([
    computed
], QuestionPassState.prototype, "storedFilterStates", null);
__decorate([
    computed
], QuestionPassState.prototype, "isInStoredFilterList", null);
__decorate([
    computed
], QuestionPassState.prototype, "isFiltered", null);
__decorate([
    action.bound
], QuestionPassState.prototype, "addToStoredFilters", null);
__decorate([
    action.bound
], QuestionPassState.prototype, "removeFromStoredFilters", null);
__decorate([
    action.bound
], QuestionPassState.prototype, "disableThisPassState", null);
__decorate([
    action.bound
], QuestionPassState.prototype, "enableForUser", null);
__decorate([
    action.bound
], QuestionPassState.prototype, "toggleFilter", null);
